import { useState } from "react";
import InputMask from "react-input-mask";

export default function InputField(props) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      className={`${
        isFocused ? "border-[#00B0AD]" : null
      } flex border p-2 w-[350px] gap-2 items-center rounded-[6px]`}
    >
      <div className={`${isFocused ? "text-[#00B0AD]" : "text-[#6B7280]"}`}>
        {props.icon}
      </div>
      <input
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="flex-1 outline-none placeholder:text-[14px]"
        type={props.type}
        placeholder={props.placeholder}
        onChange={props.onChange}
      />
    </div>
  );
}

export const DEAInput = ({ value, onChange, ariaTitle, isRequired, title, disabled }) => (
  <div title={ariaTitle}>
    <div className="font-semibold uppercase text-[12px] text-gray-600">
      {title} <span className="text-red-500">{isRequired ? "*" : null}</span>
    </div>
    <InputMask
      mask="aa9999999"
      maskChar=""
      value={value}
      onChange={onChange}
      placeholder="DEA Number (FS1234563)"
      disabled={disabled}
      className="border text-sm focus:border-primary duration-300 font-medium outline-none border-gray-300 p-2 w-full rounded-[4px] disabled:cursor-not-allowed"
    >
      {(inputProps) => <input {...inputProps} type="text" />}
    </InputMask>
  </div>
);

export const NPIInput = ({ value, onChange, ariaTitle, isRequired, title, disabled }) => (
  <div title={ariaTitle}>
    <div className="font-semibold uppercase text-[12px] text-gray-600">
      {title} <span className="text-red-500">{isRequired ? "*" : null}</span>
    </div>
    <InputMask
      mask="9999999999"
      maskChar=""
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="NPI Number (1234567893)"
      className="border text-sm focus:border-primary duration-300 font-medium outline-none border-gray-300 p-2 w-full rounded-[4px] disabled:cursor-not-allowed"
    >
      {(inputProps) => <input {...inputProps} type="text" />}
    </InputMask>
  </div>
);
